module.exports = __webpack_public_path__ + "static/img/D01-杭州学军中学教育集团文渊中学.4655997.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/D01-杭州学军中学教育集团文渊中学.png
// module id = eG/7
// module chunks = 0